<template lang="pug">
  v-container
    v-toolbar(dark :color="colors.primary")
      h2 Ingreso de Correlativos
    v-card.pa-2
      v-form(ref="form")
          v-layout(row wrap v-if="ready")
              v-flex.xs12.md6.pa-2
                  v-text-field(
                      ref="ticketInput"
                      outline
                      label="N°Boleta Inicial"
                      v-model="initialTicketNumber"
                      @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                      :rules="[rules.required]"
                      mask="############"
                  )
              v-flex.xs12.md6.pa-2
                  v-text-field(
                      ref="finalTicketInput"
                      outline
                      label="N°Boleta Final"
                      @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                      v-model="finalTicketNumber"
                      :rules="[rules.required]"
                      mask="############"
                  )
              v-flex.xs12.md6.pa-2
                  v-text-field(
                      ref="invoiceInput"
                      outline
                      label="N°Factura Inicial"
                      @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                      v-model="initialInvoiceNumber"
                      :rules="[rules.required]"
                      mask="############"
                  )
              v-flex.xs12.md6.pa-2
                  v-text-field(
                      ref="finalInvoiceInput"
                      outline
                      label="N°Factura Final"
                      v-model="finalInvoiceNumber"
                      :rules="[rules.required]"
                      @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                      mask="############"
                  )
              v-flex.xs12.md6.pa-2
                  v-text-field(
                      ref="creditNoteInput"
                      outline
                      label="N°Nota de Crédito Inicial"
                      v-model="initialCreditNoteNumber"
                      @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                      :rules="[rules.required]"
                      mask="############"
                  )
              v-flex.xs12.md6.pa-2
                  v-text-field(
                      ref="finalCreditNoteInput"
                      outline
                      label="N°Nota de Crédito final"
                      v-model="finalCreditNoteNumber"
                      @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                      mask="############"
                  )
              v-flex.xs12.md6.pa-2
                  v-text-field(
                      ref="transbankInput"
                      outline
                      label="N°Comprobante de Transbank inicial"
                      v-model="initialTransbankNumber"
                      :rules="[rules.required]"
                      mask="######"
                      @blur="handleTbkNumber()"
                      @keydown.enter="mixHandleFocus(focusOrder, ()=>{})"
                  )
              v-flex.xs12.md6.pa-2.d-flex.text-sm-center
                SupervisorUniqueKeyModal(
                  ref="authModal"
                  :available="checkForm"
                  @check-key="submit"
                  )
</template>

<script>
import JSUtils from '@/mixins/reusable_mixins/JSUtils'
import SupervisorUniqueKeyModal from '@/components/SupervisorUniqueKey/Modal'
import * as s from '../../services/API/Integration'
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'set-counters',
    data() {
        return {
            initialInvoiceNumber: '',
            initialTicketNumber: '',
            initialCreditNoteNumber: '',
            initialTransbankNumber: '',
            finalInvoiceNumber: '',
            finalTicketNumber: '',
            finalCreditNoteNumber: '',
            loading: false,
            ready: false,
        }
    },
    computed: {
        rules: function() {
            return {
                required: value =>
                    !!value || 'Este campo no puede estar vacío.',
                rounded: value =>
                    parseInt(value) % 10 === 0 ||
                    'Debe ingresar un valor multiplo de 10',
                requiredSelect: value =>
                    !!value || 'Debe seleccionar un valor.',
                tbklength: value => {
                    if (isNaN(value)) {
                        return 'Debe ser un número'
                    }
                    if (value.length != 6) {
                        return 'Debe tener 6 digitos'
                    }
                    return true
                },
            }
        },
        ...mapGetters('AuthModule', { cashDeskID: 'cashDeskID' }),
        focusOrder: function() {
            let order = [
                { val: this.initialTicketNumber, ref: 'ticketInput' },
                { val: this.finalTicketNumber, ref: 'finalTicketInput' },
                { val: this.initialInvoiceNumber, ref: 'invoiceInput' },
                { val: this.finalInvoiceNumber, ref: 'finalInvoiceInput' },
                { val: this.initialCreditNoteNumber, ref: 'creditNoteInput' },
                {
                    val: this.finalCreditNoteNumber,
                    ref: 'finalCreditNoteInput',
                },
                { val: this.initialTransbankNumber, ref: 'transbankInput' },
            ]
            return order
        },
        checkForm() {
            return this.focusOrder
                .filter(f => f.ref !== 'finalCreditNoteInput')
                .every(f => f.val)
        },
    },
    methods: {
        handleTbkNumber() {
            let tbk = this.initialTransbankNumber
            let len = '' + this.initialTransbankNumber
            len = len.length
            let dif = 6 - len
            if (dif && dif > 0) {
                for (let i = 0; i < dif; i++) {
                    tbk = '0' + tbk
                }
            }
            this.initialTransbankNumber = tbk
        },
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
        }),
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            resetStateUniqueKeyModule: 'resetState',
            setUniqueKey: 'setUniqueKey',
            setPermission: 'setPermission',
        }),
        errSnack(message) {
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body: message,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        successSnack(message) {
            let payload = {
                typeMessage: 'success',
                message: {
                    title: 'Éxito',
                    body: message,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        async submit() {
            this.setPermission(
                this.mixAuthCodePermissions.EXECUTE_CHANGE_VOUCHER_COUNTER
            )
            this.loading = true
            let r = await this.authorize()
            if (![200, 201, 'success'].includes(r.status)) {
                let message =
                    r.error && r.error.includes('No query results for model')
                        ? 'Código Incorrecto'
                        : r.message
                this.errSnack(message)
                return
            }
            if (!r.is_authorized) {
                this.errSnack('No autorizado')
                return
            }
            try {
                let res = await s.sendIntegrationTicketNumber(
                    this.initialTicketNumber,
                    this.finalTicketNumber
                )
                res = await s.sendIntegrationInvoiceTicketNumber(
                    this.initialInvoiceNumber,
                    this.finalInvoiceNumber
                )
                res = await s.sendIntegrationCreditNoteNumber(
                    this.initialCreditNoteNumber,
                    this.finalCreditNoteNumber
                )
                res = await s.sendTransbankNumber(
                    parseInt(this.initialTransbankNumber)
                )
                this.loading = false
                this.$nextTick(() => {
                    this.successSnack('Correlativos fijados exitosamente')
                })
            } catch (e) {
                let message =
                    e.response && e.response.data
                        ? e.response.data.error
                        : 'Error'
                this.errSnack(message)
            }
        },
        async fetchCounters() {
            let r = await s.getAllCounters(this.cashDeskID)
            Object.assign(this.$data, r)
        },
    },
    watch: {
        loading(val) {
            if (val) {
                let payload = {
                    typeMessage: 'info',
                    message: {
                        title: 'Cargando',
                        body: 'Espere por favor',
                    },
                    timeout: 0,
                    showProgress: true,
                    showCloseBtn: false,
                    closeBtnMessage: 'cerrar',
                }
                this.initSnackbar(payload)
            } else {
                this.hideSnack()
            }
        },
    },
    async created() {
        this.loading = true
        await this.fetchCounters()
        this.loading = false
        this.ready = true
    },
    mixins: [JSUtils],
    components: {
        SupervisorUniqueKeyModal,
    },
}
</script>

<style></style>
